import _ from 'lodash'
import { fetch } from './fetch'
import { hash } from './hash'
import { log } from './logger'

const gravatar = async ( email, options = {} ) => {
  log( '@coldandgoji/utilities', 'gravatar' )

  const emailHash = hash( email )
  const URL = [ 'https://www.gravatar.com/avatar/', emailHash ]

  // If image type specified, use that, otherwise default to .png
  options.image
    ? URL.push( `.${ _.toLower( options.image ) }` )
    : URL.push( '.png' )

  // Start building query array
  const query = []

  // If size specified, use that
  if ( options.size ) {
    query.push( `s=${ options.size }` )
  }

  // If default specified, use that
  options.default
    ? query.push( `d=${ options.default }` )
    : query.push( 'd=404' )

  // If query parameters present, add query string separator
  if ( query.length ) {
    URL.push( '?' )
  }

  // Construct query string
  const queryString = query.join( '&' )
  URL.push( queryString )

  // Construct URL string
  const URLString = URL.join( '' )

  const response = await fetch( URLString )

  return response.status === 200
    ? URLString
    : false
}

export {
  gravatar,
}
